module.exports = __webpack_public_path__ + "img/shopping-cart.5480157e.svg";